/**
 * El catálogo completo de un espacio: lo que la persona ve al abrir la app.
 *
 * Hay dos fuentes de contenido y no se mezclan en un archivo a propósito:
 *
 *   - `bimbo.ts` está GENERADO desde `referencia/demo-original.html`. Se sobrescribe
 *     entero cada vez que corre `node scripts/generar-contenido.mjs`, así que cualquier
 *     cosa escrita ahí a mano se pierde.
 *   - `fijas.ts` es contenido real de campaña, escrito a mano desde la transcripción de
 *     la capacitación. Nadie lo regenera.
 *
 * Este archivo es el único punto donde se juntan. Quien necesite «todos los cursos»
 * importa de acá y no de ninguno de los dos.
 *
 * El orden: los cursos de campaña van primero porque son los que la impulsadora tiene que
 * llevar antes de salir a tienda; los de la demo quedan detrás. Los `orden` de la demo se
 * corren acá y no en su archivo justamente porque su archivo se regenera.
 */
import type { Curso } from '../../domain/types';
import { CURSOS_BIMBO, ESPACIO_BIMBO, PREMIOS_BIMBO } from './bimbo';
import { CURSOS_FIJAS } from './fijas';

const DESPLAZAMIENTO_DEMO = CURSOS_FIJAS.length;

const CURSOS_DEMO: Curso[] = CURSOS_BIMBO.map((curso) => ({
  ...curso,
  orden: curso.orden + DESPLAZAMIENTO_DEMO,
}));

export const CURSOS: Curso[] = [...CURSOS_FIJAS, ...CURSOS_DEMO];

export { ESPACIO_BIMBO, PREMIOS_BIMBO };
